import Fingerprint from "fingerprintjs";
export default {
  // 获取浏览器指纹
  getFingerPrint() {
    var fingerprint = new Fingerprint().get();
    return fingerprint;
  },
  getCookie(name) {
    var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    var arr = document.cookie.match(reg);
    if (arr) {
      return unescape(arr[2]);
    } else {
      return null;
    }
  },
  setCookie(name, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie =
      name +
      "=" +
      escape(value) +
      (expiredays == null ? "" : ";expires=" + exdate.toGMTString());
  },
  delCookie(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(name);
    function getCookie(name) {
      var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      var arr = document.cookie.match(reg);
      if (arr) {
        return unescape(arr[2]);
      } else {
        return null;
      }
    }
    if (cval != null) {
      document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    }
  },
  dateFormat(timer) {
    // 处理时间为秒的情况
    if (timer < 9999999999) {
      timer = timer * 1000;
    }
    var date = new Date(timer);
    var year = date.getFullYear(); // 取得四位数的年份
    var month = date.getMonth() + 1; // 返回0~11之间的数字，0代表一月，11代表12月
    var day = date.getDate(); // 返回天数，0~31，getDay()返回的是星期几（0~6）
    var hour = date.getHours(); // 获取小时
    var minute = date.getMinutes(); // 获取分钟
    var second = date.getSeconds(); // 获取秒
    // console.log(timer, year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second)
    return (
      year +
      "-" +
      ("0" + month).slice(-2) +
      "-" +
      ("0" + day).slice(-2) +
      " " +
      ("0" + hour).slice(-2) +
      ":" +
      ("0" + minute).slice(-2) +
      ":" +
      ("0" + second).slice(-2)
    );
  },
  /**
   * 根据步长值计算出精度
   * @param {步长值:0.00001 精度:5} value
   * @returns
   */
  calPrecision(value) {
    value = this.toNonExponential(value);
    if (Math.floor(value) === value) return 0;
    if (value.toString().split(".").length === 1) {
      return 0;
    }
    return value.toString().split(".")[1].length || 0;
  },

  /**
   * 不使用科学计数
   * @param {*} num
   * @returns
   */
  toNonExponential(num) {
    var m = num.toExponential().match(/\d(?:\.(\d*))?e([+-]\d+)/);
    return num.toFixed(Math.max(0, (m[1] || "").length - m[2]));
  },
  /**
   * 根据精度num生成步长：0.00001     例 5：表示 0.00001
   * 如果num 为负数，代表小数点前几位  例 -5：表示 100000
   * @param {精度值} num
   */
  createIncreament(num) {
    // num = Math.abs(num);
    num = Number(num);
    let re = 0;
    if (num > 0) {
      let s = "0.";

      for (let i = 0; i < num - 1; i++) {
        s = s + "0";
      }
      s = s + "1";
      re = Number(s);
    } else if (num < 0) {
      re = Math.pow(10, Math.abs(num));
    } else if (num === 0) {
      re = 1;
    }
    return re;
  },
  // 保留小数位（不四舍五入）
  formatDecimal(num, decimal) {
    num = num.toString();
    let index = num.indexOf(".");
    if (index !== -1) {
      num = num.substring(0, decimal + index + 1);
    } else {
      num = num.substring(0);
    }
    // return parseFloat(num).toFixed(decimal);
    num = parseFloat(num);
    return this.tofixed2(num,decimal);
  },


 tofixed2(num, n) {
    // 要取多少位小数，先乘10的多少次方
    num *= Math.pow(10, n);
    // 再四舍五入取整，因为toFixed有四舍五入
    num = Math.round(num);
    // 再除以10的多少次方就是保留多少位的小数了
    num /= Math.pow(10, n);
    // console.log(num);
    return num;
},


  /**
   * 数字精度处理
   * @param {*} number  数字
   * @param {*} p 精度：-4，-3，-2，-1,0,1,2,3,4
   * 1：保留一位小数
   * 0：不保留小数
   * -1：个为为0
   * -2：个为为0，十位为0
   * @returns
   */
  truncateNumber(number, p) {
    let strNum = number.toString();
    let decimalPointIndex = strNum.indexOf('.');

    // 处理整数部分的截断
    if (p < 0) {
      // 如果没有小数点，则视为整数并处理
      if (decimalPointIndex === -1) {
        // 简单的整数截断
        return parseInt(strNum.slice(0, strNum.length + p + 1));
      } else {
        // 有小数点，但我们需要截断整数部分
        // 截断整数部分并移除小数点及以后的所有内容
        return parseInt(strNum.slice(0, decimalPointIndex + p + 1));
      }
    }

    // 处理小数部分的截断（p >= 0）
    if (p >= 0) {
      // 如果没有小数点，则直接返回原数（或根据需要返回整数）
      if (decimalPointIndex === -1) {
        return parseInt(strNum);
      }

      // 截断小数部分
      // 注意：这里我们不需要Math.floor，因为我们直接通过字符串操作来截断
      let integerPart = strNum.slice(0, decimalPointIndex + 1);
      let fractionPart = strNum.slice(decimalPointIndex + 1);
      let truncatedFractionPart = fractionPart.slice(0, p);

      // 拼接整数部分和截断后的小数部分
      return parseFloat(integerPart + truncatedFractionPart);
    }
  }

};
